import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility.js";
import issueService from "./report-service.js";
import commonAPIService from "../../common/js/common-api-service";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    actionList: [],
    mainPage: "",
    favouriteList: [],
    pageUrl: "",
    subPage: "",
    showAdd: false,
    subPageUrl: "",
    backSlash: true,
    backSlashParent: true,
    issueId: "",
    issueTrackerData: [],
    updateStatusData: [],
    filesTable: [],
    selectedUpdatedStatus: "",
    userNotes: "",
    updatedHistoryTable: [],
    showNewNotes: false,
    pageName: "",
    file: "",
    files: "",
    selectedProject: 0,
    projectList: [],
    fileList: [],
    noFiles: true,
    dragging: false,
    max2000Rule: [(v) => (v || "").length <= 2000 || "Max Length of 2000 character", (v) => !!v || "Field is required"],
    updateHistoryHeader: [
      { text: "Status", align: "start", value: "status", class: "primary customwhite--text" },
      { text: "Updated Date", align: "start", value: "u_date_history", class: "primary customwhite--text" },
      { text: "Updated By", value: "u_by_history", class: "primary customwhite--text" },
      { text: "Comments", value: "comments", class: "primary customwhite--text" },
    ],
    statusMap: {
      New: { text: "New", class: "new" },
      Duplicate: { text: "Duplicate", class: "duplicate" },
      "In-Progress": { text: "In-Progress", class: "inprogress" },
      "Dev-Fixed": { text: "Dev-Fixed", class: "devfix" },
      "In-Testing": { text: "In-Testing", class: "intest" },
      Resolved: { text: "Resolved", class: "resolved" },
      Closed: { text: "Closed", class: "closed" },
      UserDeleted: { text: "UserDeleted", class: "userdelete" },
      default: { text: "Inactive", class: "inactive" },
    },
  }),
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    this.mainPage = "Settings";
    this.pageUrl = "report-issue-details";
    this.subPageUrl = "report-issue";
    this.subPage = "Report Issue/Feedback";
    this.pageName = "Report Issue Details";
    let actionData = await AddFavourite.getParentPageAction(this.userId, this.subPageUrl);
    this.actionList = actionData?.actionList;
    if (this.$route.params.issueId !== undefined) {
      this.issueId = atob(this.$route.params.issueId);
      this.issueDetails();
    } else {
      this.$router.push(`/report-issue`);
    }
  },
  methods: {
    //Reset function
    resetFunction() {
      this.issueTrackerData = [];
      this.updateStatusData = [];
      this.filesTable = [];
      this.selectedUpdatedStatus = "";
      this.userNotes = "";
      this.updatedHistoryTable = [];
      this.showNewNotes = false;
      this.file = "";
      this.files = "";
      this.fileList = [];
      this.selectedProject = 0;
      this.projectList = [];
      this.noFiles = true;
      this.dragging = false;
    },
    // Function to get CSS class of the text
    getStatusClass(status) {
      return this.statusMap[status]?.class || this.statusMap.default.class;
    },
    // Fucntion to get Status Text
    getStatusText(status) {
      return this.statusMap[status]?.text || this.statusMap.default.text;
    },
    //Update Status Change
    updateStatusChange() {
      if (this.selectedUpdatedStatus !== "" && this.selectedUpdatedStatus !== undefined) {
        this.showNewNotes = true;
        this.userNotes = "";
      }
    },
    // Issue Details
    async issueDetails() {
      this.getUpdateStatus();
      this.getProjectList();
      this.updatedHistoryTable = [];
      this.filesTable = [];
      this.changeBugStatusDialog = true;
      let detailsObj = {
        pass: 7,
        userId: 0,
        issue_id: this.issueId,
      };
      let data = await issueService.postIssueTracker("post", detailsObj, false);
      const newArr = data?.map((obj) => {
        return {
          ...obj,
          udate: Utility.displayDateFormat(obj.udate),
          cdate: Utility.displayDateFormat(obj.cdate),
          sch_completion_date: Utility.displayDateFormat(obj.sch_completion_date),
        };
      });
      this.issueTrackerData = newArr;
      this.selectedProject = this.issueTrackerData[0]?.proj_key;
      if (this.issueTrackerData[0]?.issue_updates !== null && this.issueTrackerData[0]?.issue_updates != undefined) {
        this.updatedHistoryTable = this.issueTrackerData[0]?.issue_updates;
        this.updatedHistoryTable.forEach((element) => {
          element.u_date_history = Utility.displayDateFormat(element.u_date_history);
        });
      }
      if (this.issueTrackerData[0]?.file_details !== null) this.filesTable = this.issueTrackerData[0]?.file_details;
    },
    //Get Update Status
    async getUpdateStatus() {
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 11,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.updateStatusData = data;
      }
    },
    //Download file function
    async downloadFile(item) {
      let showMessage = true;
      let downloadLink = await issueService.getIssueImages("get", item, showMessage);
      if (downloadLink !== undefined && downloadLink !== null) {
        window.open(downloadLink, "_blank").focus();
      }
    },
    async submitIssue() {
      let validate = this.issueTrackerData[0]?.status !== "New" ? this.$refs.userNotesForm?.validate() : true;
      if (validate) {
        if (this.file !== "") {
          const formData = new FormData();
          formData.append("files", this.fileList[0]);
          let issueObj = {
            description: this.issueTrackerData[0]?.description,
            UserId: parseInt(this.userId),
            pass: 5,
            issue_id: this.issueTrackerData[0]?.issue_id,
            comments: this.userNotes ? this.userNotes : "User edited the description",
            status: this.selectedUpdatedStatus ? this.selectedUpdatedStatus : 1,
            issue_type_id: this.issueTrackerData[0]?.issue_type_id,
            proj_key: parseInt(this.selectedProject),
          };
          let showMessage = true;
          let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
          if (issueTrackerData.Result[0]) {
            let uploadImage = await commonAPIService.postIssueImages("post", this.issueId, formData, showMessage);
            if (uploadImage !== undefined) {
              this.file = "";
              this.noFiles = true;
              this.resetFunction();
              this.issueDetails();
            }
          }
        } else {
          let issueObj = {
            UserId: parseInt(this.userId),
            pass: 5,
            issue_id: this.issueTrackerData[0]?.issue_id,
            comments: this.userNotes ? this.userNotes : "User edited the description",
            status: this.selectedUpdatedStatus ? this.selectedUpdatedStatus : 1,
            files: "",
            issue_type_id: this.issueTrackerData[0]?.issue_type_id,
            description: this.issueTrackerData[0]?.description,
            proj_key: parseInt(this.selectedProject),
          };
          let showMessage = true;
          let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
          if (issueTrackerData.Result[0]) {
            this.resetFunction();
            this.issueDetails();
          }
        }
      }
    },
    //Get Project List
    async getProjectList() {
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 13,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.projectList = data;
      }
    },
    //Change event of the upload
    onChange(e) {
      this.files = e.target.files || e.dataTransfer.files;
      if (!this.files.length) {
        this.dragging = false;
        return;
      } else {
        this.noFiles = false;
        if (this.files.length > 1) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Max 1 files can be uploaded.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.noFiles = true;
          this.dragging = false;
          this.files = "";
        }
        for (let i = 0; i < this.files.length; i++) {
          this.createFile(this.files[i]);
        }
      }
    },
    //Checking file details
    createFile(file) {
      if (file.size > 15000000) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "File size is more than 15MB",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      this.file = file;
      this.dragging = false;
      this.fileList.push(file);
    },
    //Removing dragged file
    removeFile(name) {
      this.fileList = this.fileList.filter((x) => x.name !== name);
      if (!this.fileList.length > 0) {
        this.noFiles = true;
        this.file = "";
        this.dragging = false;
      }
    },
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
